import classNames from 'classnames'
import BSCard from 'react-bootstrap/Card'

import Card from '@/components/Card/Card'
import { CardLabelVariantType, PageCardType } from '@/types/card'

import styles from './CardPanel.module.scss'

type Props = {
  card: PageCardType
  className?: string
  labelVariant?: CardLabelVariantType
}

const CardPanel = ({ card, className, labelVariant }: Props) => (
  <BSCard className={classNames(styles.container, className, 'shadow-sm')}>
    <Card card={{ ...card, url: card.url || '' }} fullCard={card} labelVariant={labelVariant} pageCommander={card} />
  </BSCard>
)

export default CardPanel
